import type { PriceListBuilderValidated } from './schemas';
import type { PriceList, PriceListRule } from './types';

/** The builder's automatic-pricing block as API rules. Percentages are stored as fractions. */
export function builderRules(state: PriceListBuilderValidated): PriceListRule[] {
  if (!state.automaticPricing) {
    return [];
  }

  const { percentageVariation, priceListSource, exchangeRate } = state.automaticPricing;

  return [
    {
      source_price_list_slug: priceListSource,
      adjustment_percentage: percentageVariation ? percentageVariation.amount / 100.0 : 0,
      adjustment_direction: percentageVariation?.direction ?? 'minus',
      currency_exchange_rate: exchangeRate,
    },
  ];
}

/**
 * Builds the create payload from validated builder state. Shared by the full builder form and the
 * onboarding one-click discount path so a list made either way is byte-for-byte identical.
 */
export function priceListBuilderToPriceList(state: PriceListBuilderValidated): PriceList {
  return {
    slug: state.handle,
    name: state.name,
    currency_code: state.currency,
    source: 'custom',
    rules: builderRules(state),
  };
}
